import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ClientService } from 'src/app/@core/services/client.service';

@Component({
  selector: 'app-editor-custom-component-footer-config',
  templateUrl: 'footer-config.component.html'
})
export class FooterConfigComponent implements OnInit, AfterViewInit {
  @Input() item: any;
  @Input() customData: any;
  @Input() homeSettings: any;
  @Output() public sendEvent = new EventEmitter<any>();
  @ViewChild('privacyPolicyEditor', { static: false }) privacyPolicyEditor: ElementRef;
  @ViewChild('termsOfUseEditor', { static: false }) termsOfUseEditor: ElementRef;

  pageList: any;

  constructor(
    public clientService: ClientService
  ) {
  }

  ngOnInit() {
    this.initDefaultSettings();
    this.getPages();
  }

  ngAfterViewInit() {
    this.updateEditorContent();
  }

  initDefaultSettings() {
    if (!this.item) {
      this.item = {};
    }
    if (this.item.footerVisibility === undefined) {
      this.item.footerVisibility = 'visible';
    }
    if (this.item.footerStyle === undefined) {
      this.item.footerStyle = 'default';
    }
    if (this.item.footerShowSections === undefined) {
      this.item.footerShowSections = true;
    }
    if (this.item.footerShowMyPage === undefined) {
      this.item.footerShowMyPage = true;
    }
    if (this.item.footerShowPrivacyPolicy === undefined) {
      this.item.footerShowPrivacyPolicy = false;
    }
    if (this.item.footerPrivacyPolicyText === undefined) {
      this.item.footerPrivacyPolicyText = '';
    }
    if (this.item.footerShowTermsOfUse === undefined) {
      this.item.footerShowTermsOfUse = false;
    }
    if (this.item.footerTermsOfUseText === undefined) {
      this.item.footerTermsOfUseText = '';
    }
    if (!Array.isArray(this.item.footerPagesItems)) {
      this.item.footerPagesItems = [];
    }
    if (!Array.isArray(this.item.footerSelectedSections)) {
      this.item.footerSelectedSections = [];
    }
  }

  getAvailablePageSections(): Array<{ id: any, name: string, type: string }> {
    const sections: Array<{ id: any, name: string, type: string }> = [];
    const addedKeys = new Set<string>();
    const EXCLUDED_TYPES = ['header', 'banner', 'search', 'navbar', 'sidebar', 'navbarmobile', 'footer'];

    const addSection = (name: string, type: string, id: any) => {
      if (!name || name.trim() === '') return;
      if (type && EXCLUDED_TYPES.includes(type.toLowerCase())) return;

      const key = `${name.trim()}_${type}`;
      if (!addedKeys.has(key)) {
        addedKeys.add(key);
        sections.push({
          id: id || key,
          name: name.trim(),
          type: type || 'section'
        });
      }
    };

    const extractTitle = (sec: any): string => {
      if (!sec) return '';
      if (sec.title) {
        if (typeof sec.title === 'object' && sec.title.text && typeof sec.title.text === 'string' && sec.title.text.trim() !== '') {
          return sec.title.text.trim();
        }
        if (typeof sec.title === 'string' && sec.title.trim() !== '') {
          return sec.title.trim();
        }
      }
      if (sec.design && sec.design.title) {
        if (typeof sec.design.title === 'object' && sec.design.title.text && typeof sec.design.title.text === 'string' && sec.design.title.text.trim() !== '') {
          return sec.design.title.text.trim();
        }
        if (typeof sec.design.title === 'string' && sec.design.title.trim() !== '') {
          return sec.design.title.trim();
        }
      }
      if (sec.name && typeof sec.name === 'string' && sec.name.trim() !== '') {
        return sec.name.trim();
      }
      return '';
    };

    if (this.homeSettings) {
      const containers = [
        this.homeSettings.main,
        this.homeSettings.top,
        this.homeSettings.sidebarLeft,
        this.homeSettings.sidebar
      ];

      containers.forEach(container => {
        if (Array.isArray(container)) {
          container.forEach((sec, idx) => {
            if (!sec || !sec.type || EXCLUDED_TYPES.includes(sec.type.toLowerCase())) {
              return;
            }
            let title = extractTitle(sec);
            if (!title) {
              title = this.formatTypeToLabel(sec.type);
            }
            if (title) {
              addSection(title, sec.type, sec.id || (sec.type + '_' + idx));
            }
          });
        }
      });
    }

    if (Array.isArray(this.pageList)) {
      this.pageList.forEach((sec: any, idx: number) => {
        if (sec && sec.name) {
          const type = sec.type || 'page_section';
          if (!EXCLUDED_TYPES.includes(type.toLowerCase())) {
            addSection(sec.name, type, sec.id || ('page_sec_' + idx));
          }
        }
      });
    }

    return sections;
  }

  formatTypeToLabel(type: string): string {
    const labels: { [key: string]: string } = {
      'slides': 'Slides',
      'mini': 'Mini Cards',
      'influenciadores': 'Programa de Influenciadores',
      'artigos': 'Artigos',
      'journey': 'Jornadas',
      'cursos-sessao': 'Cursos por Seção',
      'video-sessao': 'Vídeos por Seção',
      'evento-sessao': 'Eventos por Seção',
      'aulas-rapidas-sessao': 'Aulas Rápidas por Seção',
      'news-section': 'Notícias',
      'gallery': 'Galeria'
    };
    return labels[type] || (type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Sessão');
  }

  isSectionSelected(section: { id: any, name: string, type: string }): boolean {
    if (!this.item || !Array.isArray(this.item.footerSelectedSections)) {
      return false;
    }
    return this.item.footerSelectedSections.some(
      s => (s.id && section.id && s.id === section.id) || (s.name === section.name && s.type === section.type)
    );
  }

  toggleSectionSelection(section: { id: any, name: string, type: string }): void {
    if (!this.item.footerSelectedSections) {
      this.item.footerSelectedSections = [];
    }
    const index = this.item.footerSelectedSections.findIndex(
      s => (s.id && section.id && s.id === section.id) || (s.name === section.name && s.type === section.type)
    );

    if (index >= 0) {
      this.item.footerSelectedSections.splice(index, 1);
    } else {
      this.item.footerSelectedSections.push({
        id: section.id,
        name: section.name,
        type: section.type
      });
    }

    this.item.footerPagesItems = this.item.footerSelectedSections.map(s => s.id);
  }

  updateEditorContent() {
    if (this.privacyPolicyEditor && this.privacyPolicyEditor.nativeElement) {
      this.privacyPolicyEditor.nativeElement.innerHTML = this.item.footerPrivacyPolicyText || '';
    }
    if (this.termsOfUseEditor && this.termsOfUseEditor.nativeElement) {
      this.termsOfUseEditor.nativeElement.innerHTML = this.item.footerTermsOfUseText || '';
    }
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  getPhotoWithTarget(target: any, $event: any): void {
    this.item[target] = $event.path;
  }

  setAlign(element: any, align: string): void {
    element.align = align;
  }

  getPages() {
    this.clientService.allPages().subscribe(res => {
      this.pageList = res.data;
    });
  }

  getPhoto(target: any, $event: any): void {
    if (target === 'logoLight') {
      this.item.logoLight = $event.path;
    }
    if (target === 'logoDark') {
      this.item.logoDark = $event.path;
    }
    if (target === 'logoFooter') {
      this.item.logoFooter = $event.path;
    }
    if (target === 'logoEAD') {
      this.item.logoEAD = $event.path;
    }
    if (target === 'logoHelpdesk') {
      this.item.logoHelpdesk = $event.path;
    }
    if (target === 'emblem') {
      this.item.emblem = $event.path;
    }
  }

  execEditorCommand(command: string, value: string = null, target: string = 'privacy'): void {
    document.execCommand(command, false, value);
    if (target === 'terms') {
      this.syncTermsOfUseText();
    } else {
      this.syncPrivacyPolicyText();
    }
  }

  addEditorLink(target: string = 'privacy'): void {
    const url = prompt('Digite o endereço (URL) do link:');
    if (url) {
      this.execEditorCommand('createLink', url, target);
    }
  }

  onPrivacyPolicyInput(event: any): void {
    this.item.footerPrivacyPolicyText = event.target.innerHTML;
  }

  onPrivacyPolicyBlur(event: any): void {
    this.item.footerPrivacyPolicyText = event.target.innerHTML;
  }

  syncPrivacyPolicyText(): void {
    if (this.privacyPolicyEditor && this.privacyPolicyEditor.nativeElement) {
      this.item.footerPrivacyPolicyText = this.privacyPolicyEditor.nativeElement.innerHTML;
    }
  }

  onTermsOfUseInput(event: any): void {
    this.item.footerTermsOfUseText = event.target.innerHTML;
  }

  onTermsOfUseBlur(event: any): void {
    this.item.footerTermsOfUseText = event.target.innerHTML;
  }

  syncTermsOfUseText(): void {
    if (this.termsOfUseEditor && this.termsOfUseEditor.nativeElement) {
      this.item.footerTermsOfUseText = this.termsOfUseEditor.nativeElement.innerHTML;
    }
  }

}


